import React, { useEffect, useState } from "react";
import { Button, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import GenericTable from "../components/GenericTable";
import GenericModal from "../components/GenericModal";
import Spinner from "../components/Loader";
import NavBar from "../components/NavBar";
import {
  fetchSettingsRequest,
  updateSettingsRequest,
} from "../redux-saga/actions/settingsActions";
import {SettingOutlined} from '@ant-design/icons';

const Settings = () => {
  const dispatch = useDispatch();
  const settingsData = useSelector((state) => state.settings.data || {});
  const loading = useSelector((state) => state.settings.loading);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingSetting, setEditingSetting] = useState(null);
  const [modalInputs, setModalInputs] = useState([]);

  useEffect(() => {
    dispatch(fetchSettingsRequest());
  }, [dispatch]);

  const handleEdit = (record) => {
    setModalInputs([
      {
        label: record.title,
        name: "value",
        type: "text",
        required: true,
        placeholder: `Enter ${record.title}`,
      },
    ]);
    setEditingSetting(record);
    setIsModalVisible(true);
  };

  const handleUpdate = (values) => {
    if (editingSetting) {
      console.log("Values : ", values);
      const updatedSetting = { ...editingSetting, ...values };
      console.log(
        "Payload being sent to updateSettingsRequest:",
        updatedSetting
      ); // Check payload structure
      dispatch(updateSettingsRequest(updatedSetting.key, updatedSetting.value));
      notification.success({
        message: "Updated",
        description: "The setting has been updated successfully.",
      });
      setEditingSetting(null);
      setIsModalVisible(false);
    }
  };

  const columnsConfig = [
    { title: "Title", dataIndex: "title", sortable: true },
    { title: "Value", dataIndex: "value", sortable: true },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text, record) => (
        <Button onClick={() => handleEdit(record)}>Edit</Button>
      ),
    },
  ];

  const dataSource = [
    { key: "name", title: "Name", value: settingsData.name },
    {
      key: "logo",
      title: "Logo",
      value: (
        <img src={settingsData.logo} alt="Logo" style={{ maxWidth: "100px" }} />
      ),
    },
    {
      key: "primaryColor",
      title: "Primary Color",
      value: (
        <span
          style={{
            backgroundColor: settingsData.primaryColor,
            padding: "2px 10px",
            borderRadius: "4px",
          }}
        >
          {settingsData.primaryColor}
        </span>
      ),
    },
    {
      key: "secondaryColor",
      title: "Secondary Color",
      value: (
        <span
          style={{
            backgroundColor: settingsData.secondaryColor,
            padding: "2px 10px",
            borderRadius: "4px",
          }}
        >
          {settingsData.secondaryColor}
        </span>
      ),
    },
    { key: "5", title: "accessKeyId", value: settingsData.accessKeyId },
    { key: "6", title: "region", value: settingsData.region },
  ];

  return (
    <div style={{ display: "flex" }}>
      <NavBar />
      <div style={{ width: "100%", padding: "10px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "16px" }}>
      <SettingOutlined style={{ fontSize: "24px", color: "black" }} />
      <h2 style={{ margin: 0 }}>Settings</h2>
    </div>
        <div style={{ maxHeight: "calc(100vh - 120px)", overflowY: "auto" }}>
          {loading ? (
            <Spinner />
          ) : (
            <GenericTable data={dataSource} columnsConfig={columnsConfig} />
          )}
        </div>

        {isModalVisible && (
          <GenericModal
            isVisible={isModalVisible}
            handleCancel={() => setIsModalVisible(false)}
            title={
              <span>
                <SettingOutlined style={{ color: "white", marginRight: "8px" }} />
                Edit Settings
              </span>
            }
            inputs={modalInputs}
            onSubmit={handleUpdate}
            predefinedData={editingSetting || {}}
          />
        )}
      </div>
    </div>
  );
};

export default Settings;
